import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';
import {BottomMenuComponent} from './bottom-menu/bottom-menu.component';
import {ImageViewerComponent} from './image-viewer/image-viewer.component';
import {SimpleTopBarComponent} from './simple-top-bar/simple-top-bar.component';
import {LocationSearchComponent} from './location-search/location-search.component';
import {TopMenuComponent} from './top-menu/top-menu.component';
import {ComboBoxComponent} from './combo-box/combo-box.component';
import {FileUploaderComponent} from './file-uploader/file-uploader.component';
import {AgGridBtn} from './ag-grid-btn.component';
import {PaginatorComponent} from './paginator';
import {CountdownModalComponent} from './countdown-modal/countdown-modal.component';
import {CustomAccordionComponent} from './custom-accordian/custom-accordian.component';

@NgModule({
    imports: [CommonModule, FormsModule, IonicModule, TranslateModule],
    declarations: [
        BottomMenuComponent,
        ImageViewerComponent,
        SimpleTopBarComponent,
        TopMenuComponent,
        LocationSearchComponent,
        ComboBoxComponent,
        FileUploaderComponent,
        AgGridBtn,
        PaginatorComponent,
        CountdownModalComponent,
        CustomAccordionComponent,
    ],
    exports: [
        BottomMenuComponent,
        ImageViewerComponent,
        SimpleTopBarComponent,
        TopMenuComponent,
        LocationSearchComponent,
        ComboBoxComponent,
        FileUploaderComponent,
        AgGridBtn,
        PaginatorComponent,
        CountdownModalComponent,
        CustomAccordionComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule {}
